import { MetaFunction } from "@remix-run/node";
import CartPage from "~/pages/CartPage/CartPage";
import { BASE_PAGE_TITLE } from "./const";

export const meta: MetaFunction = () => ({
  title: `Cart - ${BASE_PAGE_TITLE}`,
  "twitter:title": `Cart - ${BASE_PAGE_TITLE}`,
});

const Cart = () => <CartPage />;

export default Cart;
